import { render, staticRenderFns } from "./invoicelist.vue?vue&type=template&id=dd7a885c&scoped=true&"
import script from "./invoicelist.vue?vue&type=script&lang=js&"
export * from "./invoicelist.vue?vue&type=script&lang=js&"
import style0 from "./invoicelist.vue?vue&type=style&index=0&id=dd7a885c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7a885c",
  null
  
)

export default component.exports